import * as React from 'react';
import * as _ from 'lodash';
import * as Cookies from 'universal-cookie';
import * as qs from 'query-string';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ITicketingState, ITicketListResponse, TicketingActionCreators, ICenterState, IAppState, ITicketLookupDataResponse, IContactResponse, ContactActionCreators, ITagListResponse } from '@nkr/store/index';
import { ITicket, IBaseResponse, SearchBy, ITicketListRequest } from '@nkr/models/index';
import { TicketStatus, DisplayType } from '@nkr/enums/index';
import { FormControl, Button, DropdownButton, MenuItem, Alert } from 'react-bootstrap';
import TicketCloseReopen from './ticket-close-reopen';
import AdminList from './admin-list';
import CenterList from './center-list';
import { toast } from 'react-toastify';
import { FilterDrawer } from './filter-drawer';
import Drawer from 'rc-drawer';
import NewContact from './new-contact';
import TicketingOnlyList from './ticketing-only-list';
import { ITicketForList } from '@nkr/models/ticketing/ticket-for-list';
import { downloadFile } from '@nkr/services/download-file';
import { IFilter } from './filter';
import { NewItem } from './new-item';
import { ITicketSettings } from './ticket-settings';
import filterChangeTypes from './filter-change-types';

import 'rc-drawer/assets/index.css';

interface IProps {
    centerId?: number,
    isAdmin: boolean
}

interface IStateProps {
    app: IAppState,
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getTickets: (request: ITicketListRequest, forCenter: boolean) => Promise<ITicketListResponse>,
    exportTickets: (request: ITicketListRequest) => Promise<any>,
    getLookupData: () => Promise<ITicketLookupDataResponse>,
    updateTicketStatus: (ticketId: number, status: TicketStatus) => Promise<IBaseResponse>,
    updateTicketGroup: (ticketId: number, groupId: number) => Promise<IBaseResponse>,
    changeAssignedUser: (ticketId: number, userId: number) => Promise<IBaseResponse>,
    saveNewContactFromTicketing: (firstName: string, lastName: string, email: string, phoneNumber: string) => Promise<IContactResponse>,
    getTags: () => Promise<ITagListResponse>,
    changeDisplay: (display: number) => void
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: ITicketForList[],
    assignedTo: number[],
    filter: IFilter,
    filterChanged: boolean,
    autoRefresh: number,
    closeReopen: {
        show: boolean,
        action: TicketStatus,
        data: ITicket
    },
    showNewContact: boolean,
    loading: boolean,
    currentTicket: number,
    error: string
}

class TicketList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        assignedTo: [],
        filter: {
            center: 0,
            type: -1,
            status: [1, 2, 5],
            tier: -1,
            group: 0,
            tags: [],
            searchBy: SearchBy.Email,
            search: '',
            startDate: moment().add(-3, 'month').format('MM/DD/YYYY'),
            endDate: moment().format('MM/DD/YYYY'),
            allOpen: false
        },
        filterChanged: false,
        autoRefresh: 0,
        closeReopen: {
            show: false,
            action: null,
            data: null
        },
        showNewContact: false,
        loading: true,
        currentTicket: 0,
        error: ''
    }

    private container: HTMLDivElement;

    componentWillMount = () => {
        document.title = 'NKR : Tickets';
    }

    componentDidMount = () => {
        let parsed = qs.parse(window.location.search);
        let display = parsed.show ? parseInt(parsed.show) : this.props.app.display;
        let autoRefresh = parsed.refresh ? parseInt(parsed.refresh) : 0;

        var cookies = new Cookies();
        var nkrTicketSettings = cookies.get('nkr-ticket-list') as ITicketSettings;

        this.props.changeDisplay(display);

        let filter = { ...this.state.filter };

        if (!this.props.centerId) {
            filter.allOpen = true;

            if (nkrTicketSettings != null) {
                filter.type = nkrTicketSettings.type;
                filter.center = nkrTicketSettings.center;
                filter.status = nkrTicketSettings.status;
                filter.tier = nkrTicketSettings.tier;

                this.setState({
                    filter,
                    autoRefresh: nkrTicketSettings.autoRefresh
                }, () => {
                    this.getData();
                });
            } else {
                filter.status = [1, 2, 5];

                this.setState({
                    assignedTo: [],
                    filter,
                    autoRefresh
                }, () => {
                    this.getData();
                });
            }
        } else {
            this.getData();
        }
    }

    handleOpen = (ticketId: number) => {
        window.location.href = '/ticketing/ticket/' + ticketId;
    }

    handleDelete = () => {

    }

    handleCloseReopen = (ticketId: number, action: TicketStatus) => {
        let data = this.props.ticketing.tickets.find(x => x.id == ticketId);

        this.setState({
            closeReopen: {
                show: true,
                action,
                data
            }
        });
    }

    handleSubmitCloseReopen = () => {
        let ticketId = this.state.closeReopen.data.id;
        let newStatus = this.state.closeReopen.action;

        this.setState({
            closeReopen: {
                show: false,
                action: null,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating ticket, one moment please...').then(() => {
                this.props.updateTicketStatus(ticketId, newStatus).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        this.getData();
                    }
                });
            });
        });
    }

    handleCancelCloseReopen = () => {
        this.setState({
            closeReopen: {
                show: false,
                action: null,
                data: null
            }
        });
    }

    handleResolve = (ticketId: number) => {
        this.props.showLoading('Updating ticket, one moment please...').then(() => {
            this.props.updateTicketStatus(ticketId, TicketStatus.Resolved).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.getData();
                }
            });
        });
    }

    handleCenterStatusFilterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let filter = { ...this.state.filter };
        filter.status = parseInt(e.currentTarget.value) > 0 ? [parseInt(e.currentTarget.value)] : [];

        this.setState({
            filter
        }, () => {
            this.getTicketsOnly();
        });
    }

    handleAssignedToChanged = (assignedTo: number[]) => {
        this.setState({
            assignedTo
        });
    }

    handleFilterChange = (property: string, value: any) => {
        let filter = _.cloneDeep(this.state.filter);

        switch (property) {
            case filterChangeTypes.TYPE:
                filter.type = value;
                break;

            case filterChangeTypes.GROUP:
                filter.group = value;
                break;

            case filterChangeTypes.CENTER:
                filter.center = value;
                break;

            case filterChangeTypes.TIER:
                filter.tier = value;
                break;

            case filterChangeTypes.STATUS:
                filter.status = value;
                break;

            case filterChangeTypes.SEARCH_BY:
                filter.searchBy = value;
                break;

            case filterChangeTypes.SEARCH:
                filter.search = value;
                break;

            case filterChangeTypes.START_DATE:
                filter.startDate = value;
                break;

            case filterChangeTypes.END_DATE:
                filter.endDate = value;
                break;

            case filterChangeTypes.RESET:
                filter.type = value;
                break;
            case filterChangeTypes.ALL_OPEN:
                filter.type = value
        }

        this.setState({
            filter,
            filterChanged: true
        });
    }

    handleFilter = () => {
        this.setState({
            filterChanged: false
        }, () => {
            this.setCookie();
            this.getTicketsOnly();
        });
    }

    handleExport = () => {
        let { type, group, tier, status: statusList, searchBy, search: searchValue, startDate, endDate, allOpen } = this.state.filter;

        let ticketType = type >= 0 ? type : null;
        let ticketGroupId = group ? group : null;
        let ticketTier = tier >= 0 ? tier : null;
        let centerId = this.props.centerId != null ? this.props.centerId : null;

        let request: ITicketListRequest = {
            ticketType,
            ticketGroupId,
            ticketTier,
            statusList,
            centerId,
            searchBy,
            searchValue,
            startDate,
            endDate,
            allOpen
        };

        this.props.showLoading('Generating CSV file, one moment please...').then(() => {
            this.props.exportTickets(request).then(response => {
                this.props.hideLoading();
                downloadFile(response.data, 'tickets.csv', 'text/csv');
            });
        });
    }

    handleResetFilters = (excludeStatus: boolean) => {
        let filter = {
            ...this.state.filter,
            center: 0,
            type: -1,
            tier: -1,
            group: 0,
            search: '',
            startDate: moment().add(-3, 'month').format('MM/DD/YYYY'),
            endDate: moment().format('MM/DD/YYYY'),
            tags: []
        };

        if (excludeStatus) {

            if (filter.allOpen) {
                filter.allOpen = false;
            }

            this.setState({
                assignedTo: [],
                filter
            });
        } else {
            filter.status = [];

            this.setState({
                assignedTo: [],
                filter
            });
        }
    }

    handleRestoreFilterDefaults = () => {
        let filter = {
            ...this.state.filter,
            center: 0,
            type: -1,
            status: [1, 2, 5],
            tier: -1,
            group: 0,
            tags: [],
            searchBy: SearchBy.Email,
            search: '',
            startDate: moment().add(-3, 'month').format('MM/DD/YYYY'),
            endDate: moment().format('MM/DD/YYYY'),
            allOpen: true
        };

        this.setState({
            filter
        });
    }

    handleCreateTicket = () => {
        window.location.href = `/center/${this.props.centerId}/action-center/support/create-ticket`;
    }

    handleNew = (key: any) => {
        if (key == NewItem.Ticket)
            window.location.href = `/ticketing/ticket/new`;

        if (key == NewItem.Email)
            window.location.href = `/ticketing/ticket/compose-email`;

        if (key == NewItem.Contact) {
            this.setState({
                showNewContact: true
            });
        }
    }

    handleAllOpen = () => {
        let isAdmin = this.props.isAdmin;
        let allOpen = !this.state.filter.allOpen && isAdmin;
        let currentFilter = this.state.filter;

        let filterChanged = this.state.filterChanged;
        
        if (allOpen) {
            currentFilter.status = [1, 2, 5];
            filterChanged = true;
        }

        let filter = { ...currentFilter, allOpen};

        this.setState({
            filter,
            filterChanged
        });
    }

    handleSaveNewContact = (firstName: string, lastName: string, email: string, phoneNumber: string) => {
        this.props.showLoading('Saving contact, one moment please...').then(() => {
            this.props.saveNewContactFromTicketing(firstName, lastName, email, phoneNumber).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    this.setState({
                        showNewContact: false
                    }, () => {
                        toast.success('New contact added')
                    });
                }
            });
        });
    }

    handleCancelNewContact = () => {
        this.setState({
            showNewContact: false
        });
    }

    handleChangeAssignedUser = (ticketId: number, userId: number) => {
        this.props.showLoading('Updating assigned user, one moment please...').then(() => {
            this.props.changeAssignedUser(ticketId, userId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Assigned user changed successfully.');
                    this.getData();
                }
            });
        });
    }

    handleChangeStatus = (ticketId: number, status: number) => {
        this.props.showLoading('Updating ticket, one moment please...').then(() => {
            this.props.updateTicketStatus(ticketId, status).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Status changed successfully.');
                    this.getData();
                }
            });
        });
    }

    handleChangeGroup = (ticketId: number, groupId: number) => {
        this.props.showLoading('Updating ticket, one moment please...').then(() => {
            this.props.updateTicketGroup(ticketId, groupId).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Status changed successfully.');
                    this.getData();
                }
            });
        });
    }

    handleChangeDisplay = (display: DisplayType) => {
        this.props.changeDisplay(display);
    }

    handleAutoRefreshChange = (autoRefresh: number) => {
        this.setState({
            autoRefresh
        }, () => {
            this.setCookie();
        });
    }

    handleMouseOver = (currentTicket: number) => {
        this.setState({
            currentTicket
        });
    }

    handleMouseOut = () => {
        this.setState({
            currentTicket: 0
        });
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    getData = () => {
        let { startDate, endDate } = this.state.filter;
        let forCenter = this.props.isAdmin == false;
        let allOpen = this.props.isAdmin && this.props.app.user.group.isSuper && this.state.filter.allOpen == true;
        let statusList = this.state.filter.status;

        if (allOpen) {
            statusList = [1, 2, 5];
        }

        this.props.showLoading('Loading tickets, one moment please...').then(() => {
            let request: ITicketListRequest = {
                centerId: this.props.centerId != null ? this.props.centerId : null,
                statusList,
                startDate,
                endDate,
                allOpen 
            };

            let status = statusList;

            return Promise.all([
                this.props.getTickets(request, forCenter),
                this.props.getLookupData()
            ])
                .then(([listResponse, lookupDataResponse]) => {
                    if (listResponse.data.success) {
                        this.setState({
                            list: listResponse.data.results,
                            filter: {...this.state.filter, status},
                            error: '',
                            loading: false
                        });
                    }

                    this.props.hideLoading();
                })
                .catch(error => {
                    this.setState({
                        list: [],
                        filter: {...this.state.filter, status},
                        error: error.response.data
                    });

                    this.props.hideLoading();
                });
        });
    }

    getTicketsOnly = () => {
        let forCenter = this.props.isAdmin == false;

        this.setState({
            loading: true
        }, () => {
            let { type, group, tier, center, status: statusList, searchBy, search: searchValue, startDate, endDate, allOpen } = this.state.filter;

            allOpen = this.props.isAdmin && this.props.app.user.group.isSuper && this.state.filter.allOpen == true;
    
            if (allOpen) {
                statusList = [1, 2, 5];
            }

            let ticketType = type >= 0 ? type : null;
            let ticketGroupId = group ? group : null;
            let ticketTier = tier >= 0 ? tier : null;
            let centerId = this.props.centerId != null ? this.props.centerId : null;

            if (this.props.isAdmin) {
                centerId = center;
            }
            
            if (this.props.app.display == DisplayType.NoMenuNoTabs) {
                startDate = moment().add(-3, 'month').format('MM/DD/YYYY');
                endDate = moment().format('MM/DD/YYYY');
            }

            let request: ITicketListRequest = {
                ticketType,
                ticketGroupId,
                ticketTier,
                statusList,
                centerId,
                searchBy,
                searchValue,
                startDate,
                endDate,
                allOpen
            };

            this.props.getTickets(request, forCenter)
                .then(response => {
                    this.setState({
                        list: response.data.results,
                        loading: false,
                        error: '',
                        filter: { ...this.state.filter, startDate, endDate, status: statusList }
                    });
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        error: error.response.data,
                        list: []
                    });
                });
        });
    }

    setCookie = () => {
        let { type, group, center, status, tier, searchBy, search, allOpen } = this.state.filter;
        let autoRefresh = this.state.autoRefresh;

        var cookies = new Cookies();

        cookies.set('nkr-ticket-list', { type, group, center, status, tier, searchBy, search, autoRefresh, dateRecorded: new Date(), allOpen }, { path: '/', domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    render = () => {
        const ticketList = this.state.list;
        const centerList = this.props.ticketing.lookupData.centerList;
        const userList = this.props.ticketing.lookupData.userList;
        const statusList = this.props.ticketing.lookupData.ticketStatusList;
        const groupList = this.props.ticketing.lookupData.ticketGroupList;
        const marginTop = this.props.app.display == DisplayType.NoMenuNoTabs ? 10 : 0;
        const allOpen = this.state.filter.allOpen;

        return (
            <>
                <div ref={this.saveContainer} />
                <div className={'container-fluid'}>
                    {this.state.error != '' && (
                        <Alert bsStyle='danger'>{this.state.error}</Alert>
                    )}

                    {this.props.isAdmin == false && (
                        <div className='row' style={{ marginBottom: 20 }}>
                            <div className='col-xs-12 col-lg-12'>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div><h4 style={{ margin: 0 }}>Support</h4></div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
                                            <div style={{ marginRight: 5 }}>Status:</div>
                                            <div>
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.state.filter.status.length > 0 ? this.state.filter.status[0] : 0}
                                                    onChange={this.handleCenterStatusFilterChange}
                                                >
                                                    <option value={0}>- ALL -</option>
                                                    {this.props.ticketing.lookupData.ticketStatusList.map((item, index) =>
                                                        <option key={`st-${index}`} value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {this.props.isAdmin && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20, marginTop }}>
                                <div style={{ fontSize: 28, fontWeight: 500 }}>TICKETS</div>
                                <div style={{ textAlign: 'center' }}>
                                    {this.state.loading && (
                                        <div className='alert alert-info' style={{ marginBottom: 0, padding: 7.5, textAlign: 'center' }}>Fetching tickets...</div>
                                    )}
                                </div>

                                
                                <div style={{ display: 'inline-flex' }}>
                                    {this.props.app.user.group.isSuper && (   
                                        <div style={{ marginRight: 5 }}>
                                            <Button bsStyle={allOpen ? 'primary' : 'default'} bsSize='sm' title={'Show all tickets'} onClick={this.handleAllOpen}>All Open</Button>
                                        </div>
                                    )}

                                    <div>
                                        {!this.props.app.user.group.accessTicketing && (
                                            <DropdownButton bsSize='small' pullRight id='new-item' title='New' style={{ marginRight: 10 }} onSelect={this.handleNew}>
                                                <MenuItem eventKey={1}>Ticket</MenuItem>
                                                <MenuItem eventKey={2}>Email</MenuItem>
                                                <MenuItem eventKey={3}>Contact</MenuItem>
                                            </DropdownButton>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {this.props.app.display != DisplayType.NoMenuNoTabs && (
                                <FilterDrawer
                                    isSuper={this.props.app.user.group.isSuper}
                                    isTicketingOnly={this.props.app.user.group.accessTicketing}
                                    userId={this.props.app.user.id}
                                    assignedTo={this.state.assignedTo}
                                    filter={this.state.filter}
                                    filterChanged={this.state.filterChanged}
                                    allOpen={allOpen}
                                    userList={this.props.ticketing.lookupData.userList}
                                    centerList={centerList}
                                    ticketTypeList={this.props.ticketing.lookupData.ticketTypeList}
                                    ticketStatusList={this.props.ticketing.lookupData.ticketStatusList}
                                    ticketTierList={this.props.ticketing.lookupData.ticketTierList}
                                    ticketGroupList={this.props.ticketing.lookupData.ticketGroupList}
                                    ticketUrgencyList={this.props.ticketing.lookupData.ticketUrgencyList}
                                    onFilterChange={this.handleFilterChange}
                                    onFilter={this.handleFilter}
                                    onExport={this.handleExport}
                                    onResetFilters={this.handleResetFilters}
                                    onRestoreDefaults={this.handleRestoreFilterDefaults}
                                />
                            )}
                        </>
                    )}

                    <div className='row'>
                        <div className='col-xs-12 col-lg-12'>
                            {this.props.isAdmin && this.props.app.user.group.isSuper && (
                                <div style={{ display: 'flex' }}>
                                    <AdminList
                                        list={ticketList}
                                        userList={userList}
                                        statusList={statusList}
                                        groupList={groupList}
                                        width={'100%'}
                                        display={this.props.app.display}
                                        loading={this.state.loading}
                                        autoRefresh={this.state.autoRefresh}
                                        onOpen={this.handleOpen}
                                        onCloseReopen={this.handleCloseReopen}
                                        onResolve={this.handleResolve}
                                        onChangeAssignedUser={this.handleChangeAssignedUser}
                                        onChangeStatus={this.handleChangeStatus}
                                        onChangeGroup={this.handleChangeGroup}
                                        onChangeDisplay={this.handleChangeDisplay}
                                        onAutoRefreshChange={this.handleAutoRefreshChange}
                                        onRefreshTicketList={this.getTicketsOnly}
                                        onMouseOver={this.handleMouseOver}
                                        onMouseOut={this.handleMouseOut}
                                    />
                                </div>
                            )}

                            {this.props.isAdmin && this.props.app.user.group.isNkdo && (
                                <div style={{ display: 'flex' }}>
                                    <TicketingOnlyList
                                        list={ticketList}
                                        userList={userList}
                                        statusList={statusList}
                                        width={'100%'}
                                        display={this.props.app.display}
                                        loading={this.state.loading}
                                        autoRefresh={this.state.autoRefresh}
                                        onOpen={this.handleOpen}
                                        onCloseReopen={this.handleCloseReopen}
                                        onResolve={this.handleResolve}
                                        onChangeAssignedUser={this.handleChangeAssignedUser}
                                        onChangeStatus={this.handleChangeStatus}
                                        onChangeDisplay={this.handleChangeDisplay}
                                        onAutoRefreshChange={this.handleAutoRefreshChange}
                                        onRefreshTicketList={this.getTicketsOnly}
                                        onMouseOver={this.handleMouseOver}
                                        onMouseOut={this.handleMouseOut}
                                    />
                                </div>
                            )}

                            {this.props.isAdmin == false && (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '15vh' }}>
                                        <div style={{ 
                                                //border: '1px solid black', 
                                                padding: '30px', 
                                                textAlign: 'center', 
                                                //boxShadow: '0px 0px 8px rgba(0,0,0,0.1)',
                                            }}>
                                            <strong>
                                                To submit a Support Ticket please click the button below.
                                            </strong>
                                            <div style={{ marginTop: '15px' }}>
                                                <button style={{ backgroundColor: '#337ab7', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' }} onClick={() => window.open('https://www.kidneyregistry.com/about/contact-us/', '_blank')}>
                                                    Create Ticket
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <CenterList
                                        list={ticketList}
                                        centerId={this.props.centerId}
                                        onOpen={this.handleOpen}
                                        onDelete={() => null}
                                        onCloseReopen={this.handleCloseReopen}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <TicketCloseReopen
                    show={this.state.closeReopen.show}
                    action={this.state.closeReopen.action}
                    data={this.state.closeReopen.data}
                    isCenter={this.props.centerId != null && this.props.app.user.group.isCenter}
                    onCloseReopen={this.handleSubmitCloseReopen}
                    onCancel={this.handleCancelCloseReopen}
                />

                <Drawer
                    width='20vw'
                    // handler={false}
                    placement='right'
                    getContainer={this.getContainer}
                    open={this.state.showNewContact}
                >
                    <NewContact
                        onSave={this.handleSaveNewContact}
                        onCancel={this.handleCancelNewContact}
                    />
                </Drawer>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getTickets: (request, forCenter) => {
            return dispatch(TicketingActionCreators.getTickets(request, forCenter));
        },
        exportTickets: (request) => {
            return dispatch(TicketingActionCreators.exportTickets(request));
        },
        getLookupData: () => {
            return dispatch(TicketingActionCreators.getLookupData());
        },
        updateTicketStatus: (ticketId, ticketStatus) => {
            return dispatch(TicketingActionCreators.updateTicketStatus(ticketId, ticketStatus));
        },
        updateTicketGroup: (ticketId, groupId) => {
            return dispatch(TicketingActionCreators.updateTicketGroup(ticketId, groupId));
        },
        changeAssignedUser: (ticketId, userId) => {
            return dispatch(TicketingActionCreators.changeAssignedUser(ticketId, userId));
        },
        saveNewContactFromTicketing: (firstName, lastName, email, phoneNumber) => {
            return dispatch(ContactActionCreators.saveNewContactFromTicketing(firstName, lastName, email, phoneNumber));
        },
        getTags: () => {
            return dispatch(TicketingActionCreators.getTags());
        },
        changeDisplay: (display: number) => {
            dispatch(AppActionCreators.changeDisplay(display));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(TicketList);
